/**
 * SIMGE SETI
 *
 * Neden hazir bir paket degil de kendi setimiz:
 *  - Dis paket, uygulama paketine yuzlerce kullanmadigimiz simge tasir.
 *  - Marka isareti (marka.tsx) zaten ayni teknikle ciziliyor; iki farkli
 *    cizim dili yan yana durunca arayuz derlenmemis gorunuyor.
 *  - `currentColor` sayesinde her simge bulundugu yerin rengini alir; koyu
 *    temada ayri bir dosya gerekmez.
 *
 * Kurallar: 24x24 kutu, yalnizca CIZGI (dolgu yok), 1.75 kalinlik, yuvarlak
 * uclar. Hepsi ayni gorsel agirlikta olsun diye tek bir olcude cizildi;
 * boyut disaridan verilir ama cizgi kalinligi otomatik dengelenir.
 */

export type SimgeAdi =
  // menu
  | "pano" | "musteri" | "alan" | "kutu" | "kurulum" | "tasima"
  | "fatura" | "abonelik" | "fiyat" | "limit" | "kullanim" | "guvenlik"
  | "mutabakat" | "alarm" | "gecmis" | "hesap"
  // eylem ve durum
  | "ok" | "carpi" | "uyari" | "bilgi" | "sag" | "asagi" | "disari"
  | "kopyala" | "indir" | "yenile" | "ara" | "ekle" | "sil"
  | "kilit" | "kilitac" | "goz" | "menu" | "gunes" | "ay" | "cikis"
  | "posta" | "takvim" | "kisiler" | "sunucu" | "anahtar" | "kalkan";

const Y: Record<SimgeAdi, JSX.Element> = {
  // ------------------------------------------------------------ menu
  pano: (
    <>
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </>
  ),
  musteri: (
    <>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </>
  ),
  alan: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18Z" />
    </>
  ),
  kutu: (
    <>
      <path d="M22 12h-6l-2 3h-4l-2-3H2" />
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11Z" />
    </>
  ),
  kurulum: (
    <>
      <path d="M21 5H14" /><path d="M10 5H3" />
      <path d="M21 12H12" /><path d="M8 12H3" />
      <path d="M21 19H16" /><path d="M12 19H3" />
      <circle cx="12" cy="5" r="2" />
      <circle cx="10" cy="12" r="2" />
      <circle cx="14" cy="19" r="2" />
    </>
  ),
  tasima: (
    <>
      <path d="m8 3-5 4 5 4" />
      <path d="M3 7h16" />
      <path d="m16 13 5 4-5 4" />
      <path d="M21 17H5" />
    </>
  ),
  fatura: (
    <>
      <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
      <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
      <path d="M12 18V6" />
    </>
  ),
  abonelik: (
    <>
      <path d="m17 2 4 4-4 4" />
      <path d="M3 11v-1a4 4 0 0 1 4-4h14" />
      <path d="m7 22-4-4 4-4" />
      <path d="M21 13v1a4 4 0 0 1-4 4H3" />
    </>
  ),
  fiyat: (
    <>
      <path d="M12.6 2.6A2 2 0 0 0 11.2 2H4a2 2 0 0 0-2 2v7.2a2 2 0 0 0 .6 1.4l8.7 8.7a2.4 2.4 0 0 0 3.4 0l6.6-6.6a2.4 2.4 0 0 0 0-3.4Z" />
      <circle cx="7.5" cy="7.5" r="1.2" />
    </>
  ),
  limit: (
    <>
      <path d="M3.4 19a10 10 0 1 1 17.2 0" />
      <path d="m12 14 4-4" />
      <circle cx="12" cy="15" r="1.4" />
    </>
  ),
  kullanim: (
    <>
      <path d="M3 3v16a2 2 0 0 0 2 2h16" />
      <path d="M18 17V9" /><path d="M13 17V5" /><path d="M8 17v-3" />
    </>
  ),
  guvenlik: (
    <>
      <path d="M20 13c0 5-3.5 7.5-7.7 9a1 1 0 0 1-.6 0C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.2-2.7a1.2 1.2 0 0 1 1.6 0C14.5 3.8 17 5 19 5a1 1 0 0 1 1 1Z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  mutabakat: (
    <>
      <path d="M12 3v18" />
      <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" />
      <path d="M7 21h10" />
      <path d="m16 16 3-7 3 7a5 5 0 0 1-6 0Z" />
      <path d="m2 16 3-7 3 7a5 5 0 0 1-6 0Z" />
    </>
  ),
  alarm: (
    <>
      <path d="M10.3 21a2 2 0 0 0 3.4 0" />
      <path d="M3.3 15.3A1 1 0 0 0 4 17h16a1 1 0 0 0 .7-1.7C19.4 14 18 12.5 18 8A6 6 0 0 0 6 8c0 4.5-1.4 6-2.7 7.3" />
    </>
  ),
  gecmis: (
    <>
      <path d="M3 12a9 9 0 1 0 9-9 9.8 9.8 0 0 0-6.7 2.7L3 8" />
      <path d="M3 3v5h5" />
      <path d="M12 7v5l4 2" />
    </>
  ),
  hesap: (
    <>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="10" r="3" />
      <path d="M6.6 19.4a6 6 0 0 1 10.8 0" />
    </>
  ),

  // ------------------------------------------------------------ eylem
  ok: <path d="M20 6 9 17l-5-5" />,
  carpi: <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
  uyari: (
    <>
      <path d="m21.7 18-8-14a2 2 0 0 0-3.4 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.7-3Z" />
      <path d="M12 9v4" /><path d="M12 17h.01" />
    </>
  ),
  bilgi: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 16v-4" /><path d="M12 8h.01" />
    </>
  ),
  sag: <path d="m9 18 6-6-6-6" />,
  asagi: <path d="m6 9 6 6 6-6" />,
  disari: (
    <>
      <path d="M15 3h6v6" /><path d="M10 14 21 3" />
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    </>
  ),
  kopyala: (
    <>
      <rect x="8" y="8" width="14" height="14" rx="2" />
      <path d="M4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2" />
    </>
  ),
  indir: (
    <>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <path d="m7 10 5 5 5-5" /><path d="M12 15V3" />
    </>
  ),
  yenile: (
    <>
      <path d="M3 12a9 9 0 0 1 9-9 9.8 9.8 0 0 1 6.7 2.7L21 8" />
      <path d="M21 3v5h-5" />
      <path d="M21 12a9 9 0 0 1-9 9 9.8 9.8 0 0 1-6.7-2.7L3 16" />
      <path d="M8 16H3v5" />
    </>
  ),
  ara: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </>
  ),
  ekle: <><path d="M5 12h14" /><path d="M12 5v14" /></>,
  sil: (
    <>
      <path d="M3 6h18" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </>
  ),
  kilit: (
    <>
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </>
  ),
  kilitac: (
    <>
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 9.9-1" />
    </>
  ),
  goz: (
    <>
      <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  menu: <><path d="M4 6h16" /><path d="M4 12h16" /><path d="M4 18h16" /></>,
  gunes: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2" /><path d="M12 20v2" />
      <path d="m4.9 4.9 1.4 1.4" /><path d="m17.7 17.7 1.4 1.4" />
      <path d="M2 12h2" /><path d="M20 12h2" />
      <path d="m6.3 17.7-1.4 1.4" /><path d="m19.1 4.9-1.4 1.4" />
    </>
  ),
  ay: <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />,
  cikis: (
    <>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="m16 17 5-5-5-5" /><path d="M21 12H9" />
    </>
  ),
  posta: (
    <>
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-9 5.7a2 2 0 0 1-2 0L2 7" />
    </>
  ),
  takvim: (
    <>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4" /><path d="M8 2v4" /><path d="M3 10h18" />
    </>
  ),
  kisiler: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <circle cx="12" cy="10" r="2.6" />
      <path d="M7.5 17.5a5 5 0 0 1 9 0" />
    </>
  ),
  sunucu: (
    <>
      <rect x="2" y="3" width="20" height="8" rx="2" />
      <rect x="2" y="13" width="20" height="8" rx="2" />
      <path d="M6 7h.01" /><path d="M6 17h.01" />
    </>
  ),
  anahtar: (
    <>
      <circle cx="7.5" cy="15.5" r="4.5" />
      <path d="m21 2-10.3 10.3" />
      <path d="m15.5 7.5 2.5 2.5" />
      <path d="m18.5 4.5 2.5 2.5" />
    </>
  ),
  kalkan: (
    <path d="M20 13c0 5-3.5 7.5-7.7 9a1 1 0 0 1-.6 0C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.2-2.7a1.2 1.2 0 0 1 1.6 0C14.5 3.8 17 5 19 5a1 1 0 0 1 1 1Z" />
  ),
};

export function Simge({
  ad,
  boyut = 18,
  etiket,
}: {
  ad: SimgeAdi;
  boyut?: number;
  /** Verilirse ekran okuyucu bunu okur; verilmezse simge suslemedir */
  etiket?: string;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={boyut}
      height={boyut}
      fill="none"
      stroke="currentColor"
      // Kucuk boyutlarda ince cizgi silikleser, buyukte kabalasir: kalinligi
      // boyutla ters orantili dengeliyoruz ki 14px ile 32px ayni agirlikta gorunsun.
      strokeWidth={Math.max(1.4, Math.min(2.1, 42 / boyut))}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={etiket ? "img" : undefined}
      aria-label={etiket}
      aria-hidden={etiket ? undefined : true}
      style={{ display: "block", flex: "none" }}
    >
      {etiket && <title>{etiket}</title>}
      {Y[ad]}
    </svg>
  );
}

/** Menu yolundan simge adi — tek yerde dursun ki menu degisince kaymasin */
export const YOL_SIMGE: Record<string, SimgeAdi> = {
  "/": "pano",
  "/musteriler": "musteri",
  "/alanadlari": "alan",
  "/kutular": "kutu",
  "/kurulum": "kurulum",
  "/tasima": "tasima",
  "/faturalar": "fatura",
  "/abonelikler": "abonelik",
  "/fiyatlar": "fiyat",
  "/limitler": "limit",
  "/kullanim": "kullanim",
  "/guvenlik": "guvenlik",
  "/mutabakat": "mutabakat",
  "/alarmlar": "alarm",
  "/denetim": "gecmis",
  "/hesabim": "hesap",
};
